import React, { useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';
import Styles from '../../lib/Styles';
import classes from '../SelectField.module.scss';

interface IVINDescriptionProps {
  initialValue?: string | null;
  selectedVINDescription?: string | null;
  setSelectedVINDescription: Function;
  listOfWMIs?: string | null;
  onChange: Function;
  readOnly?: boolean;
}

export default function SelectVINDescription(props: IVINDescriptionProps) {
  const { selectedVINDescription, setSelectedVINDescription, listOfWMIs, onChange, readOnly } = props;
  let initialValue = useRef(props.initialValue);
  const cx = new Styles(classes).cx;

  const [lengthVINDescription, setLengthVINDescription] = useState<number>(selectedVINDescription ? selectedVINDescription.length : 0);
  const [showHelper, setShowHelper] = useState<boolean>(false);
  const maxNumberOfCharacters: number = 300;

  useEffect(() => {
    if (initialValue.current) {
      setLengthVINDescription(initialValue.current.length);
      setSelectedVINDescription(initialValue.current);
      initialValue.current = undefined;
    }
  }, [setSelectedVINDescription])

  // Don't allow more than 300 digits to be entered.
  const handleVINDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    let lengthValue = value.length;
    if (lengthValue > maxNumberOfCharacters) {
      value = value.substr(0, maxNumberOfCharacters);
    }
    setLengthVINDescription(value.length);
    setSelectedVINDescription(value);
    onChange();
  };

  return (
    <>
      <form className={cx('root')} noValidate autoComplete="off">
        <div>
          <TextField
            disabled={readOnly}
            label="VIN File Description"
            helperText={!showHelper ? '' : (maxNumberOfCharacters - lengthVINDescription).toLocaleString() + ' characters left'}
            multiline
            defaultValue={undefined}
            inputProps={{
              readOnly: readOnly
            }}
            variant="outlined"
            value={selectedVINDescription}
            onInput={handleVINDescriptionChange}
            onFocus={() => setShowHelper(true)}
            onBlur={() => setShowHelper(false)}
            placeholder="Enter VIN description here."
            required={true}
          />
        </div>
      </form>
    </>
  );
}
